import axios from "axios";
import {Base_URL} from "../url"

export const fetchItems = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/Item/${id}`);

    console.log(response.data, 'item master')
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching items!";
  }
};

export const downloadItemsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/Item/DownloadItemsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading items data!";
  }
};